import React from "react";

interface CheckedProps {
  className?: string;
}

export const LightIcon = ({ className }: CheckedProps) => (
  <svg
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.53125 0C7.05208 0 8.34375 0.541667 9.40625 1.625C10.4896 2.6875 11.0312 3.97917 11.0312 5.5C11.0312 6.875 10.5729 8.08333 9.65625 9.125C9.28125 9.54167 8.92708 10.0625 8.59375 10.6875C8.26042 11.2917 8.07292 11.7292 8.03125 12V14.3438C8.03125 14.4479 8 14.5417 7.9375 14.625L7.1875 15.7812C7.08333 15.9271 6.9375 16 6.75 16H4.3125C4.125 16 3.97917 15.9271 3.875 15.7812L3.125 14.625C3.0625 14.5417 3.03125 14.4479 3.03125 14.3438V12C2.98958 11.75 2.80208 11.3125 2.46875 10.6875C2.13542 10.0625 1.78125 9.54167 1.40625 9.125C0.489583 8.08333 0.03125 6.875 0.03125 5.5C0.03125 4.02083 0.552083 2.73958 1.59375 1.65625C2.65625 0.552083 3.96875 0 5.53125 0ZM7.03125 14.1875V14H4.03125V14.1875L4.5625 15H6.5L7.03125 14.1875ZM7.03125 13V12H4.03125V13H7.03125ZM8.90625 8.46875C9.65625 7.61458 10.0312 6.625 10.0312 5.5C10.0312 4.25 9.59375 3.1875 8.71875 2.3125C7.84375 1.4375 6.78125 1 5.53125 1C4.23958 1 3.16667 1.44792 2.3125 2.34375C1.45833 3.21875 1.03125 4.27083 1.03125 5.5C1.03125 6.625 1.40625 7.61458 2.15625 8.46875C2.78125 9.19792 3.30208 10.0417 3.71875 11H7.34375C7.76042 10.0417 8.28125 9.19792 8.90625 8.46875ZM5.53125 2C5.67708 2 5.79167 2.05208 5.875 2.15625C5.97917 2.23958 6.03125 2.35417 6.03125 2.5C6.03125 2.64583 5.97917 2.77083 5.875 2.875C5.79167 2.95833 5.67708 3 5.53125 3C4.84375 3 4.25 3.25 3.75 3.75C3.27083 4.22917 3.03125 4.8125 3.03125 5.5C3.03125 5.64583 2.97917 5.77083 2.875 5.875C2.79167 5.95833 2.67708 6 2.53125 6C2.38542 6 2.26042 5.95833 2.15625 5.875C2.07292 5.77083 2.03125 5.64583 2.03125 5.5C2.03125 4.54167 2.375 3.71875 3.0625 3.03125C3.75 2.34375 4.57292 2 5.53125 2Z"
      fill="black"
    />
  </svg>
);

LightIcon.defaultProps = {
  className: "",
};
